import { useContext, useMemo } from "react";
import { ContextEDH } from "@context/ContextEDH";
import useContextUrl from "@common/hooks/useContextUrl";
import useNavigationUrl from "@common/hooks/useNavigationUrl";

const useBookingAccess = () => {
  const { workspace, scenario, origin } = useContextUrl();
  const { state } = useContext(ContextEDH);
  const { baseRoutes, bookingListUrl } = useNavigationUrl();

  const base = state?.base?.base;
  const userCanEditBookings = base?.user?.abilities?.can_edit_bookings;

  const hasBookingModuleAccess = useMemo(
    () => base?.modules?.some(module => module?.code === "bookings" && module?.accesible),
    [base?.modules],
  );

  const isAdminBooking = hasBookingModuleAccess && userCanEditBookings && !!origin;

  const bookingModuleUrl = useMemo(() => {
    if (!hasBookingModuleAccess) return null;

    if (isAdminBooking) {
      return bookingListUrl();
    }

    return `${baseRoutes?.bookingList}${workspace}/${scenario}${origin ? `/${origin}` : ""}`;
  }, [hasBookingModuleAccess, isAdminBooking, baseRoutes, workspace, scenario]);

  return {
    isBookingAccesible: hasBookingModuleAccess,
    isAdminBooking,
    bookingModuleUrl,
  };
};

export default useBookingAccess;
